const touchMap = new WeakMap();

export default  {
    data() {
        return {
            maskedInput: []
        };
    },
    methods: {
        delayTouch($v) {
            $v.$reset();
            if (touchMap.has($v)) {
                clearTimeout(touchMap.get($v));
            }
            touchMap.set($v, setTimeout($v.$touch, 1000));
        },
        maskedDelayTouch($v) {
            if (!this.maskedInput.includes($v)) {
                this.maskedInput.push($v);

                return;
            }
            this.delayTouch($v);
        }
    }
}
